import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import { isPhone } from "@cadmakers-ui/core";
import FeedbackListContainer from "../../../Feedback/Components/Common/FeedbackList/FeedbackListContainer";
import { FeedbackCategory, FeedbackSortOption } from "../../../Feedback/Constants/feedbackEnums";
import { ActiveAppName, SubscriptionState, appService } from "../..";
import { SearchContextType } from "../../../Layout/Constants/LayoutEnums";
import { SearchContext } from "../../../Layout/Models/SearchContext";
import { IAppState } from "../../../Common";
import SubscribeToAppButtonContainer from "../Common/SubscribeToAppButton/SubscribeToAppButtonContainer";
import "../../Styles/ApplicationResourceRequestsContainer.scss";

type TParams = {
  id: string;
};

interface StateProps {
  appSubState: Record<string, SubscriptionState>;
}

const mapStateToProps = (state: IAppState): StateProps => ({
  appSubState: appService.getApplicationSubStatesFromAppState(state)
});

const CLASSNAME_PREFIX = "ApplicationResourceRequestsContainer__";
const RESOURCE_REQUEST = [FeedbackCategory.ResourceRequest];

export const ApplicationResourceRequestsContainer: React.FC<RouteComponentProps<TParams> &
  StateProps> = props => {
  const context: SearchContext = {
    type: SearchContextType.App,
    itemId: props.match.params.id
  };

  return (
    <div>
      <div className={`${CLASSNAME_PREFIX}heading`}>
        <span className={`${CLASSNAME_PREFIX}heading-title`}>
          {!isPhone && (
            <h2>
              <ActiveAppName /> Resource Requests
            </h2>
          )}
        </span>
        <span className={`${CLASSNAME_PREFIX}heading-subscribe`}>
          {!isPhone && props.appSubState[props.match.params.id] === SubscriptionState.Active ? (
            <SubscribeToAppButtonContainer appId={props.match.params.id} />
          ) : null}
        </span>
      </div>
      <FeedbackListContainer
        listId={`APP_RESOURCE_REQUEST_LIST_${props.match.params.id}`}
        context={context}
        sort={FeedbackSortOption.DateCreated}
        isAscending={false}
        fullscreen
        enableDownload
        paging
        treeView
        selectedCategories={RESOURCE_REQUEST}
      />
    </div>
  );
};

export default connect(mapStateToProps)(ApplicationResourceRequestsContainer);
